export const CheckMark = () => {
    return (
        <svg
            width="13"
            height="11"
            viewBox="0 0 13 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M1 6.5L4 10L12 1" stroke="currentColor" />
        </svg>
    );
};
